import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    hotSearch: [],
    cateList: [],
    showAll: false,
    currentFirstCate: '全部', // 当前第一级类目
    currentCateId: '0',
    bookInfo: null,
    bookList: [], // 搜索到的书籍
    page: 1,
    total: 0,
    showGoodsSearchMenu: false,
    showGoodsCateMenu: false,
    isChoosen: false,
    choosenIndex: '-1',
    isShowIconRight: false,
    isFixedNavBar: false,
    currentTagId: '',
    goodsSearhWord: '',
  },
  actions: {
    setData: ({ commit, state }, object) => {
      Object.keys(object).map(item => {
        commit('SET_DATA', { name: item, value: object[item] })
      })
    },
  },
  mutations: {
    SET_DATA: (state, { name, value }) => {
      state[name] = value
    },
    PUSH_DATA: (state, { name, value }) => {
      state[name] = state[name].concat(value)
    },
  },
})
